const initialState = {
    data:[],
    image:[],
    
    
  
  };
  
  const MOProfileReducers = (state = initialState, action: any) => {
    switch (action.type) {
            case 'FETCH_GET_SUCCESS':
            return {... state, data:action.payload};
            case 'FETCH_IMAGE_SUCCESS':
            return {... state, image:action.payload};
            
            
           
            
           
          


      default:
        return state;
    }
  };
  
  export default MOProfileReducers;
  
  